"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridLabeler = void 0;
const color_js_1 = require("@ngageoint/color-js");
const grid_js_1 = require("@ngageoint/grid-js");
const MGRSProperties_1 = require("../property/MGRSProperties");
/**
 * Grid Labeler
 */
class GridLabeler extends grid_js_1.Labeler {
    constructor(enabled, minZoom = 0, maxZoom, color = color_js_1.Color.black(), textSize = GridLabeler.DEFAULT_TEXT_SIZE, buffer = GridLabeler.DEFAULT_BUFFER) {
        super(enabled, minZoom, maxZoom, color, textSize, buffer);
    }
}
exports.GridLabeler = GridLabeler;
/**
 * Default text size
 */
GridLabeler.DEFAULT_TEXT_SIZE = MGRSProperties_1.MGRSProperties.getInstance().getDoubleProperty(true, grid_js_1.PropertyConstants.LABELER.toString(), grid_js_1.PropertyConstants.TEXT_SIZE.toString());
/**
 * Default buffer size
 */
GridLabeler.DEFAULT_BUFFER = MGRSProperties_1.MGRSProperties.getInstance().getDoubleProperty(true, grid_js_1.PropertyConstants.LABELER.toString(), grid_js_1.PropertyConstants.BUFFER.toString());
//# sourceMappingURL=GridLabeler.js.map